import React from 'react'

const MenuButton = ({onClick ,isMenuOpen}) => {
  return (
    <div class="relative inline-flex  group"     onClick={onClick}>
    <div
        class="absolute transitiona-all duration-1000 opacity-20 dark:opacity-35 -inset-px bg-gradient-to-r from-[#44BCFF] via-[#0063E9] to-[#2F70E4] rounded-xl blur-lg group-hover:opacity-40 dark:group-hover:opacity-50 group-hover:-inset-1 group-hover:duration-200 animate-tilt">
    </div>
        <button 
         className="p-3 bg-gradient-to-bl from-light-glass1 dark:from-dark-glass1 to-light-glass2 dark:to-dark-glass2 backdrop-blur-xl shadow-xl  border-2 border-light-secondary dark:border-dark-glassStrock1 rounded-full md:hidden flex flex-col justify-center items-center w-10 h-10 order-2 md:order-none"
       
          aria-label="فتح القائمة"
        >
          <span className={`bg-light-link dark:bg-dark-subtitle block transition-all duration-300 ease-out h-0.5 w-6 rounded-sm ${isMenuOpen ? 'rotate-45 translate-y-1' : '-translate-y-0.5'}`}></span>
          <span className={`bg-light-link dark:bg-dark-subtitle block transition-all duration-300 ease-out h-0.5 w-6 rounded-sm my-0.5 ${isMenuOpen ? 'opacity-0' : 'opacity-100'}`}></span>
          <span className={`bg-light-link dark:bg-dark-subtitle block transition-all duration-300 ease-out h-0.5 w-6 rounded-sm ${isMenuOpen ? '-rotate-45 -translate-y-1' : 'translate-y-0.5'}`}></span>
        </button>
</div>
  )
}

export default MenuButton